var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/system-metrics/system-metrics.html';
var html = "<div layout=column> <report-form on-report-generated=$ctrl.generateReport($event)> </report-form> <highchart config=$ctrl.chartConfig class=naers-report ng-if=\"$ctrl.chartConfig && $ctrl.chartConfig.series\" style=overflow:hidden></highchart> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/reports/system-metrics/system-metrics.html
// module id = 732
// module chunks = 0